export default __webpack_public_path__ + "static/media/SeetaResources-logo.af6c5916.svg";